import * as dayjs from "dayjs";

const processSVSession = svSession => {
	const previousSelectedFrom = {
		value: svSession?.selectedFrom
	};
	const previousSelectedTo = {
		isHotel: !!svSession?.selectedHotel,
		value: svSession?.selectedHotel
			? svSession?.selectedHotel
			: svSession?.selectedTo
					?.split("_")
					.sort((a, b) => a - b)
					.join("_")
	};

	// Create previous selected date from svSession.selectedDate + svSession.selectedDuration
	const selectedDepartureDate = dayjs(svSession?.selectedDate ?? null);
	const initialDuration = svSession?.selectedDuration?.match(/(\d+)/)?.[0];
	const selectedReturnDate =
		!!initialDuration &&
		selectedDepartureDate.isValid() &&
		dayjs(selectedDepartureDate).add(initialDuration, "day");
	const previousSelectedDates = [];
	if (selectedDepartureDate.isValid()) {
		previousSelectedDates.push(selectedDepartureDate.toString("YYYY-MM-DD"));

		if (selectedReturnDate && selectedReturnDate?.isValid()) {
			previousSelectedDates.push(selectedReturnDate.toString("YYYY-MM-DD"));
		}
	}

	return {
		selectedFrom: previousSelectedFrom.value ? previousSelectedFrom : null,
		selectedTo: previousSelectedTo.value ? previousSelectedTo : null,
		selectedRoomsOccupancies: svSession?.selectedRoomsOccupancies ?? null,
		selectedDates: previousSelectedDates
	};
};

export default processSVSession;
export { processSVSession };
